<div class="psw-criteria-input-container">
  <mat-form-field
    [hideRequiredMarker]="false"
    [appearance]="outline ? 'outline' : 'fill'"
  >
    <mat-label *ngIf="label !== ''">{{ label }}</mat-label>
    <input
      [type]="hide ? 'text' : type"
      matInput
      [placeholder]="placeholder"
      [formControl]="control"
      autocomplete="new-password"
      (keydown)="onEnter($event)"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onTouched()"
      [errorStateMatcher]="matcher"
    />
    <mat-hint *ngIf="hint" align="start"
      ><span class="aran-field-hint">{{ hint }}</span></mat-hint
    >

    <button
      *ngIf="value && isClearable"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="handleInnerReset($event)"
    >
      <mat-icon>close</mat-icon>
    </button>

    <button
      *ngIf="obscure"
      mat-icon-button
      matSuffix
      (click)="clickObscureEvent($event)"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hide"
    >
      <mat-icon [svgIcon]="hide ? 'visibilityOff' : 'visibility'"></mat-icon>
    </button>

    <button
      *ngIf="criteriaList && criteriaList.length > 0"
      mat-icon-button
      [matMenuTriggerFor]="criteriaMenu"
      matSuffix
      [ngClass]="
        getProgress() >= 100
          ? 'psw-criteria-input-container-success-color'
          : 'psw-criteria-input-container-error-color'
      "
      (click)="onButtonclickPswCriteria($event)"
    >
      <mat-icon>info</mat-icon>
    </button>

    <mat-menu
      #criteriaMenu="matMenu"
      class="psw-criteria-input-container-menu-panel"
    >
      <div class="psw-criteria-input-container-criteria">
        <div
          *ngFor="let criteria of criteriaList"
          [ngClass]="{ valid: criteria.valid, invalid: !criteria.valid }"
        >
          <mat-icon>{{ criteria.valid ? "check_circle" : "cancel" }}</mat-icon>
          <span class="psw-criteria-input-container-criteria-message">{{
            criteria.message
          }}</span>
        </div>
      </div>
    </mat-menu>

    <mat-error *ngFor="let key of errorKeys()">
      {{ errorMessages[key] }}
    </mat-error>
  </mat-form-field>

  <mat-progress-bar
    *ngIf="criteriaList && criteriaList.length > 0"
    class="psw-criteria-input-container-progressbar"
    [value]="getProgress()"
    [color]="getProgress() < 100 ? 'warn' : null"
    [ngClass]="{
      'psw-criteria-input-container-success-color': getProgress() >= 100
    }"
  ></mat-progress-bar>
</div>
